export default "query BrandsGlossary($locale:Locale!){brandsGlossary(locale:$locale){sections{key brands{name url}}}}"